import ProductFieldOption from './ProductFieldOption'
import { camelize } from "../_helpers/functions"

export default class ProductField {
    id
    title
    name
    label
    position
    options
    type
    selectedOption = null
    mapToForm = null

    constructor(id, title, name, label, options, position, type) {
        this.id = id || ''
        this.name = name || ''
        this.title = title || ''
        this.label = label || ''
        this.options = options || []
        this.position = position || 0
        this.type = type || ''
    }
    
    getFieldLabel(){
        return this.label ? this.label.toUpperCase() : this.name
    }
    
    getComponentName(){
        return camelize(this.type)
    }
    
    static fromPlain(plainObj) {
        const options = []
        if (plainObj.options) {
            plainObj.options.forEach(option => {
                options.push(ProductFieldOption.fromPlain(option))
            })
        }

        return new ProductField(
            plainObj.id || false,
            plainObj.title || false,
            plainObj.name || false,
            plainObj.label || false,
            options || false,
            plainObj.position || false,
            plainObj.type || false,
        )
    }
    
    

    static toPlain(object) {
        const plain = {}
        Object.keys(object).forEach((item, value) => {
            plain[item] = object[item]
        })
        return plain
    }
}